<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--7 mb-5">
      <div class="row mb-3">
        <div class="col-12 col-md-12 col-xl-8 mb-3">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">เพิ่มลูกค้า</h3>
                </div>
              </div>
            </div>
            <template>
              <b-tabs>
                <b-tab :title="tab.name" v-for="( tab , index ) in tabTitle" :key="index" @click="tabKey = tab.key">
                  <formVerify
                    :disabledEmail="isDefaultEmail()"
                    :submitForm.sync="submitAddCustomer"
                    :data="data" 
                    :account="account"
                    :images="images"
                    :tabKey.sync="tabKey"
                    typeFormTab="cod"
                    ref="registerMember"
                  />
                </b-tab>
              </b-tabs>
            </template>
          </card>
        </div>
        <div class="col-12 col-md-12 col-xl-4">
          <div class="row">
            <div class="col-12 mb-3">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">ค้นหาลูกค้า</h3>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <label>
                      <span class="text-danger">*</span> เบอร์โทรศัพท์
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="เบอร์โทรศัพท์"
                      v-model="member.tel"
                    />
                  </div>
                  <div class="col-12">
                    <label>
                      <span class="text-danger">*</span> เลขบัตรประชาชน / หมายเลขพาสปอร์ต
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="เลขบัตรประชาชน"
                      v-model="member.card_id"
                    />
                  </div>
                  <div class="col-12">
                    <div class="py-3">
                      <button class="btn btn-info btn-block mb-3" @click="fetchMember()" >
                        ค้นหา
                      </button>
                    </div> 
                  </div>
                </div>
              </card>
            </div>
            <div class="col-12 mb-3">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">การจัดการ</h3>
                    </div>
                  </div>
                </div>
                <div class="row p-3 mt-1">
                  <div class="col-6">
                    <button class="btn btn-info btn-block btn-icon py-3 mb-3" @click="showComfirmModal()">
                      บันทึก
                    </button>
                  </div>
                  <div class="col-6">
                    <button class="btn btn-secondary btn-block btn-icon py-3 mb-3" @click="reset()">
                      คืนค่า
                    </button>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatBank from "@/plugins/formatBank.js";
import validatePop from "../plugins/validatePop.js"
import formVerify from '@/components/custom/brance/FormVerify'
import { checkPersonID } from "@/plugins/posHelper.js";
const API_URL = process.env.VUE_APP_API;
export default {
    name:"registermember",
    components: {
        formVerify
    },
    data(){
      return{
        busy: false,
        submitAddCustomer: false,
        tabKey:'person',
        userLogin: "",
        data:{
          name_title: "",
          tax_id: "",
          laser_code: "",
          date_birthday: "",
          date_expiry: "",
          email: "",
          name: "",
          address: "",
          state: "",
          district: "",
          province: "",
          postcode: "",
          tel: "",
          errorTax: false,
        },
        account: [{
          account_id: '',
          account_name: '',
          account_branch: '',
          account_bank: '',
          branch_code: '',
        }],
        member: {
          tel:"",
          card_id:"",
        },
        ListNameTitle: [
          { code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
          { code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
          { code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'}
        ],
        bank: formatBank,
        images:[
          {
            name:'image_tax_front',
            lable:'รูปภาพบัตรประชาชนด้านหน้า',
            file:null,
            preview:"",
          },
          {
            name:'image_tax_back',
            lable:'รูปภาพบัตรประชาชนด้านหลัง',
            file:null,
            preview:"",
          },
          {
            name:'image_tax_double',
            lable:'รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน', 
            file:null,
            preview:"", 
          },
          {
            name:'image_account',
            lable:'รูปภาพสมุดบัญชี',
            file:null,
            preview:"",
          },
        ]
      }
    },
    mounted(){
      if( this.isDefaultEmail() ){
        this.data.email = this.$route.params.email
      }
    },
    methods:{
      // addAccount(){
      //   this.account.push({
      //     account_id: '',
      //     account_name: '',
      //     account_branch: '',
      //     account_bank: '',
      //     branch_code: '',
      //   });
      // },
      // deleteAccount(index){
      //   this.account.splice(index, 1);
      // },
      isDefaultEmail() {
        return !!this.$route.params.email;
      },
      createCustomer(){
        this.submitAddCustomer = true
        if( this.tabKey == 'person' ){
          this.$refs.registerMember[0].$v.$touch();
          if (this.$refs.registerMember[0].$v.$invalid) {
            return false
          }
        }else if( this.tabKey == 'company' ){
          this.$refs.registerMember[1].$v.$touch();
          if (this.$refs.registerMember[1].$v.$invalid) {
            return false
          }
        }else{
          this.$refs.registerMember[2].$v.$touch();
          if (this.$refs.registerMember[2].$v.$invalid) {
            return false
          }
        }
        if ( this.data.tax_id.length == 13 && /^([0-9]{1,})$/.test(this.data.tax_id) ){
          let checkCardId = checkPersonID(this.data.tax_id);
          this.data.errorTax = false;
          if( !checkCardId ){
              this.data.errorTax = true;
              return false;
          }
        }
        if(this.account[0].branch_code.length == 3){
          this.account[0].branch_code = "0"+this.account[0].branch_code
        }
        this.busy = true
        this.$http
          .post(
            API_URL + "/member",
            {
              tax_id: this.data.tax_id,
              tel: this.data.tel,
              email: this.data.email,
              account: this.account,
              name_title: this.data.name_title,
              name: this.data.name,
              address: this.data.address,
              state: this.data.state,
              district: this.data.district,
              province: this.data.province,
              postcode: this.data.postcode,
              images: this.images,
              laser_code: this.data.laser_code,
              date_birthday: this.data.date_birthday,
              date_expiry: this.data.date_expiry,
              type: this.tabKey
            },
            {
              headers: {
                Token: localStorage.getItem("access_token")
              }
            }
          )
          .then(res => {
            let checkError = validatePop( res )
              if( !checkError.status ){
                this.handleLoader();
                this.sendErrorToLine( res )
                this.showErrorModal( checkError.msg )
                return false
              }
            this.handleLoader()
            this.showSuccessComfirmModal("สมัครสมาชิกสำเร็จ")
          })
          .catch(error => { 
          });
      },
      sendErrorToLine(res){
        this.$http.post( API_URL + "/lineNotify/error", {
            error: res
          },
          {
            headers: {
              "Content-Type": "application/json",
              Token: localStorage.getItem("access_token")
            }
        })
      },
      uploadImage(index,e) {
        if (e.target.files.length < 1) return false;
        const image = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(image);
        new Promise((resolve, reject) => {
          reader.onload = e => {
            this.$set(this.images[index], 'preview' , e.target.result)
            resolve( reader.result )
          }
        }).then( base64 => {
          let base64str = base64.split('base64,')[1]
          let decoded = atob(base64str)
          if( decoded.length > 2097152 ){ //byte 
              this.images[index].file = null;
              this.images[index].preview = "";
            this.showErrorModal('ขนาดรูปต้องไม่เกิน 2Mb')
            return false
          }
        })
      },
      handleLoader(){
        this.busy = !this.busy
      },
      fetchMember(){
        if(!this.member.tel || !this.member.card_id){
          this.showErrorModal( "กรุณากรอกข้อมูลในการค้นหาลูกค้าให้ครบถ้วน" );
          return false;
        }
        this.handleLoader()
        this.$http
          .post(
            API_URL + "/member/fetch",
            {
              card_id: this.member.card_id,
              tel: this.member.tel
            },
            {
              headers: {
                Token: localStorage.getItem("access_token")
              }
            }
          )
          .then(res => {
            let data = res.data.data
            this.handleLoader()
            let checkError = validatePop( res )
              if( !checkError.status ){
                this.showErrorModal( checkError.msg )
                return false
              }
              if( data.status === 'is member' ){
                this.showSuccessModal("เป็นสมาชิกแล้ว")
              }else{
                this.showErrorModal( "ไม่เป็นสมาชิก" , 'Done')
              }

          })
          .catch(error => { 
          });
      },
      reset(){
        location.reload();
      },
      showComfirmModal() {
        this.$bvModal
          .msgBoxConfirm(`กรุณาตรวจสอบข้อมูลลูกค้าให้ถูกต้อง หลังจากยืนยันแล้วข้อมูลลูกค้าจะไม่สามารถแก้ไขได้`, {
            title: "กรุณายืนยัน",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "ยืนยัน",
            cancelTitle: "ยกเลิก",
            contentClass: "modal-confirm",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              this.createCustomer();
            }
          });
      },
      showSuccessModal(msgBody) {
        this.$bvModal.msgBoxOk(msgBody, {
          title: "SUCCESS",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "ตกลง",
          contentClass: "modal-success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        });
      },
      showSuccessComfirmModal(msgBody) {
        this.$bvModal.msgBoxOk(msgBody, {
          title: "SUCCESS",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "ตกลง",
          contentClass: "modal-success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
        .then(value => {
          if (value) {
            this.reset();
          }
         });
      },
      showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
        this.$bvModal.msgBoxOk(msgBody, {
          title: "ERROR",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: OkmsgTitle,
          contentClass: "modal-errors",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        });
      },
    },
    computed: {
      tabTitle(){
        return  [
          { key:'person', name:'บุคคลธรรมดา' },
          { key:'company', name:'นิติบุคคล' },
          { key:'passport', name:'พาสปอร์ต' }
        ]
      }
    }
};
</script>

<style>
</style>